import axios from 'axios'

export default {
  getBlobData(url) {
    return axios.get('media/' + url, {
      responseType: 'blob'
    })
  },
}
